module.exports = __webpack_public_path__ + "static/media/individual-intro.e636659d.png";